import { Form, Select } from 'antd';

const FormSelect = ({ name, label, options, rules, className, ...rest }) => {
  const stringLabel = typeof label === 'string' ? label : 'Industry';

  return (
    <Form.Item
      name={name}
      label={label}
      rules={rules} 
      className={className}
    >
      <Select
        placeholder={`Select your ${stringLabel.toLowerCase()}`}
          dropdownClassName="custom-dropdown"
        {...rest}
      >
        {options.map(option => (
          <Select.Option key={option.value} value={option.value}>
            {option.label}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  );
};

export default FormSelect;